import React from "react";
import { connect, shallowEqual } from "react-redux";
import { d3 } from "../../adapter";
import Chart from "./../../charts/temperatureChart";

class TemperatureChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.chart = undefined;
  }

  handleResize(event) {
    var el = this.chartRef.current;
    if (el) {
      this.chart.resize(parseInt(d3.select(el).style("width"), 10), false);
    }
  }

  componentDidMount() {
    var el = this.chartRef.current;
    this.chart = new Chart(
      {
        id: "chart-weather-data-temperature",
        height: 250,
        class: "chart weather-temperature",
        width: parseInt(d3.select(el).style("width"), 10), // With of the container element
      },
      this.getChartState(this.props),
      this.props.dispatch
    );

    this.chart.init(el);

    window.addEventListener("resize", () => {
      this.handleResize();
    });
  }

  shouldComponentUpdate(nextProps) {
    // Only update the chart when the props are not equal
    if (
      !shallowEqual(this.props.domain, nextProps.domain) ||
      !shallowEqual(this.props.station, nextProps.station)
    ) {
      this.chart.update(this.getChartState(nextProps));
    }

    // Change hovered state
    if (this.props.hovered !== nextProps.hovered || this.props.pinned !== nextProps.pinned) {
      this.chart.updateHoverState(nextProps.hovered, nextProps.pinned, nextProps.pinDate);
    }

    // Change the hover date
    this.chart.updateHoverDate(nextProps.hoverDate, nextProps.pinned, nextProps.pinDate);

    return false;
  }

  getChartState(props) {
    return {
      station: props.station,
      domain: props.domain,
      hoverDate: props.hoverDate,
      pinDate: props.pinDate,
      pinned: props.pinned,
    };
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    return <div className="dacom-online-chart-wrapper" ref={this.chartRef} />;
  }
}

const mapStateToProps = (state) => ({ ...state.weatherStationAnalysis });

export default connect(mapStateToProps)(TemperatureChart);
